import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flexcol flexcenter w100 textcenter" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon_header",
  xmlns: "http://www.w3.org/2000/svg",
  height: "60px",
  width: "60",
  viewBox: "0 0 24 24",
  fill: "#1d79d4"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "¡Bienvenido al buscador Spotlight de Novatrans!", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Encuentra cualquier entrada en tu base de datos de clientes, vehículos, facturas...", -1)


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


    function resetSearch() {
      document.querySelector<HTMLElement>(".searchQuery")?.focus()
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (resetSearch())),
      class: "textlink"
    }, "Comienza a buscar")
  ]))
}
}

})